module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074c4_logo_200x200.2db858f7.png";